import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Louisiana = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Louisiana Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure of material facts required; form provided by the
          Louisiana Real Estate Commission.
        </Text>

        <Text style={styles.listItem}>
          2. Property Disclosure Document: Mandatory for residential sales.
        </Text>

        <Text style={styles.listItem}>
          3. Termite Inspection: Commonly required due to local conditions.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Property Disclosure Document</Text>{' '}
          – Sellers must provide potential buyers with a full disclosure
          statement revealing the material condition of the property.
        </Text>
      </View>
    </View>
  );
};

export default Louisiana;
